import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/backoffice/new',
  title: 'Cadastrar Backoffice',
  endpoint: '/app/person',
}
